import { MessageOutlined } from '@ant-design/icons'
import { TFunction } from 'i18next'

import { Checklist } from '../../../../entities/workflow/types/workflow.types'
import { FormItemType } from '../../../shared/form-builder/constants/form-builder.constants'
import { FormBuilderConfig } from '../../../shared/form-builder/types/form-builder.types'
import styles from '../components/milestone-check/milestone-check.module.scss'

export const getMilestoneCheckTableColumns = (t: TFunction, checklistData?: Checklist) => {
  return [
    {
      title: t('common.name'),
      dataIndex: 'name',
      key: 'name',
      render: (_: any, configItem: FormBuilderConfig) => {
        if (configItem.type === FormItemType.Header) {
          return (
            <div>
              <b>{configItem.label}</b>
            </div>
          )
        }

        return <div>{configItem.label}</div>
      },
    },
    {
      title: t('common.value'),
      dataIndex: 'value',
      key: 'value',
      render: (_: any, configItem: FormBuilderConfig) => {
        return <div>{checklistData?.checklist?.[configItem.id] ?? null}</div>
      },
    },
    {
      title: '',
      dataIndex: 'message',
      key: 'message',
      width: '50px',
      render: (_: any, configItem: FormBuilderConfig) => {
        if (checklistData?.comment?.[configItem.id]?.length) {
          return (
            <div className={styles.messageNotice}>
              <MessageOutlined style={{ fontSize: 16 }} />
            </div>
          )
        } else {
          return null
        }
      },
    },
  ]
}
